import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=6c5e7df2"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports